var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwoFa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 193.397,
    height: 199.899,
    viewBox: "0 0 193.397 199.899",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3651",
    "data-name": "Path 3651",
    d: "M96.7,233.1h0C43.31,233.1,0,188.333,0,133.15H0C0,77.966,43.31,33.2,96.7,33.2h0c53.388,0,96.7,44.766,96.7,99.95h0C193.4,188.333,150.087,233.1,96.7,233.1Z",
    transform: "translate(0 -33.2)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4600",
    "data-name": "Group 4600",
    transform: "translate(-522.051 -476.05)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "new-document",
    transform: "translate(522.051 476.05)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4083",
    "data-name": "Group 4083"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4081",
    "data-name": "Group 4081",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3650",
    "data-name": "Path 3650",
    d: "M96.7,233.1h0C43.31,233.1,0,188.333,0,133.15H0C0,77.966,43.31,33.2,96.7,33.2h0c53.388,0,96.7,44.766,96.7,99.95h0C193.4,188.333,150.087,233.1,96.7,233.1Z",
    transform: "translate(0 -33.2)",
    fill: "#33c999"
  })))), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "****",
    transform: "translate(593.75 635)",
    fill: "#fbfbfc",
    fontSize: 24,
    fontFamily: "Oxygen-Bold, Oxygen",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "****")), /*#__PURE__*/React.createElement("path", {
    id: "lock-solid",
    d: "M21.862,21.787V29.05H46.152V21.787a12.145,12.145,0,0,0-24.291,0ZM12.145,29.05V21.787a21.862,21.862,0,0,1,43.723,0V29.05H58.3a9.709,9.709,0,0,1,9.716,9.683v29.05A9.709,9.709,0,0,1,58.3,77.466H9.716A9.709,9.709,0,0,1,0,67.783V38.733A9.709,9.709,0,0,1,9.716,29.05Z",
    transform: "translate(584.742 527.534)",
    fill: "#f4f5f5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoFa);
export default __webpack_public_path__ + "static/media/two-fa.0de2b666a084c319ebec772159377e2f.svg";
export { ForwardRef as ReactComponent };